import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type CreateAccountLocationMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateAccountLocationInput;
}>;

export type CreateAccountLocationMutationResult = { __typename?: 'Mutation' } & {
  createAccountLocation?: GraphQLTypes.Maybe<
    { __typename?: 'CreateAccountLocationPayload' } & Pick<GraphQLTypes.CreateAccountLocationPayload, 'locationId'> & {
        errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
        location?: GraphQLTypes.Maybe<
          { __typename?: 'AccountLocation' } & Pick<GraphQLTypes.AccountLocation, 'id'> & {
              label?: GraphQLTypes.Maybe<
                { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long' | 'short'>
              >;
            }
        >;
      }
  >;
};

export const CreateAccountLocationDocument = gql`
  mutation createAccountLocation($input: CreateAccountLocationInput!) {
    createAccountLocation(input: $input) {
      errors {
        message
        path
      }
      location {
        id
        label {
          long
          short
        }
      }
      locationId
    }
  }
`;
